import React, { Component } from 'react';

export default class ImageViewer extends Component {

	onRemoveImage = () => {
		this.props.onRemove(this.props.type);
	}

	render() {
		const { props } = this;
		return (
			<div style={{ position: 'relative', backgroundColor: '#f1f1f1', width: '350px' }}>
				{(props.shouldRemove) ?
					<div className='cross'>
						<i className="fas fa-times" style={{ fontSize: '18px', color: 'white' }} onClick={this.onRemoveImage}></i>
					</div> : null
				}
				<img src={props.src} style={{ maxWidth: '315px', objectFit: 'cover', border: '2px solid' }} alt={props.alt} />
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/commons/ImageViewer.js